import React, {Component} from "react";
import {
    Switch, Route, withRouter 
} from "react-router-dom";
import { TransitionGroup, CSSTransition } from "react-transition-group";
import {BrowserView} from 'react-device-detect';

// Global App Styles
import './App.scss';

// Components
import ScrollToTop from '../../components/ScrollToTop/ScrollToTop';
import ScrollToTopRoute from '../../components/ScrollToTopRoute/ScrollToTopRoute';
import AppLoader from '../../components/AppLoader/AppLoader';
import MagicCursor from '../../components/MagicCursor/MagicCursor';

// Containers
import Header from '../Header/Header';
import Footer from '../Footer/Footer';
import Theme from '../Theme/Theme';

// Pages
import PageHome from '../../pages/PageHome/PageHome';
import PageThemes from '../../pages/PageThemes/PageThemes';
import PageContact from '../../pages/PageContact/PageContact';
import PageCustomization from '../../pages/PageCustomization/PageCustomization';
import PageSupport from '../../pages/PageSupport/PageSupport';
import PageSupportPolicy from '../../pages/PageSupportPolicy/PageSupportPolicy';
import PageAbout from '../../pages/PageAbout/PageAbout';
import PageFAQ from '../../pages/PageFAQ/PageFAQ';
import PageNotFound from '../../pages/PageNotFound/PageNotFound';

const routes = [
  { path: "/", name: "Home", Component: PageHome, 'exact' : true },
  { path: "/themes", name: "Themes", Component: PageThemes, 'exact' : false  },
  { path: "/contact", name: "Contact", Component: PageContact, 'exact' : false  },
  { path: "/customization", name: "Customization", Component: PageCustomization, 'exact' : false  },
  { path: "/support", name: "Support", Component: PageSupport, 'exact' : false   },
  { path: "/support-policy", name: "Support Policy", Component: PageSupportPolicy, 'exact' : false  },
  { path: "/about", name: "About", Component: PageAbout, 'exact' : false  },
  { path: "/faq", name: "FAQ", Component: PageFAQ, 'exact' : false  },
  { path: "/theme/:ThemeName", name: "Theme", Component: Theme, 'exact' : false  },
  { path: "*", name: "Error 404", Component: PageNotFound, 'exact' : false  }
];

class App extends Component {
     constructor(props) {
        super(props);
        this.state = {
            loaded : false
        }
        this.updateHoverables = React.createRef();
        this.handleLoad = this.handleLoad.bind(this);
     }

    componentDidUpdate(prevProps) {
        if (this.updateHoverables.current !== null && this.props.location.pathname !== prevProps.location.pathname) {
            this.updateHoverables.current.addHoverables();
        }
    }

    componentDidMount() {
        window.addEventListener('load', this.handleLoad);
        document.body.classList.add('fade-enter-active');
    }

    componentWillUnmount() { 
        window.removeEventListener('load', this.handleLoad)  
    }    

    handleLoad() {
        this.setState({ loaded: true });
        setTimeout( () => {
        	document.body.classList.add('fade-enter-done');
        	setTimeout( () => { document.body.classList.remove('fade-enter-active', 'fade-enter-done') }, 1500 );
        }, 1500 );     
    }
   	
   	onExit() {
   		document.body.classList.add('loading');
   	}

   	onEntered() {
   		document.body.classList.remove('loading')
   	}

    render () {

        return (
            <div className={`app  ${this.state.loaded === true ? 'app--loaded' : ''}  is-anim`}>
                <AppLoader />
                <Header />
                <BrowserView>
                	<MagicCursor ref={this.updateHoverables} />
                </BrowserView>
                <ScrollToTopRoute />
                <div className="app-content">
                    <TransitionGroup component={null}>
                        <CSSTransition
                        	onEntered={this.onEntered}
                          	onExit={this.onExit}
                          	key={this.props.location.key}
                          	timeout={{ enter: 1200, exit: 600 }}
                          	classNames={'fade'}
                        >
                            <div className="switch">
                                <Switch location={this.props.location}>
                                    {routes.map(({ path, Component, exact }) => (
                                        <Route key={path} exact={exact} path={path} component={Component} />
                                    ))}
                                </Switch>
                            </div>
                        </CSSTransition>
                    </TransitionGroup>
                </div>

                <ScrollToTop />
                <Footer />
                
            </div>
        );
    }
}


export default withRouter(App);




// WEBPACK FOOTER //
// ./src/containers/App/App.js